import React, { Component } from "react";
import Slider from "react-slick";
import Modal from "components/Modal/modal";
import Helmet from "react-helmet";

import Link from "gatsby-link";

import config from "data/merchants";

import youtubePreview1 from "./images/thumbnail_grind_preview_1024.jpg";
import youtubePreview2 from "./images/thumbnail_orejen_preview_1024.jpg";
import youtubePreview3 from "./images/thumbnail_walkfresh_preview_1024.jpg";

class Entrepreneurs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      youTubeURL: ""
    };
  }

  openModal(url) {
    this.setState({
      modal: true,
      youTubeURL: url
    });
  }

  closeModal = () => {
    this.setState({
      modal: false
    });
  };

  renderModal() {
    if (this.state.modal) {
      return (
        <Modal close={this.closeModal}>
          <iframe
            width="100%"
            height="330"
            src={`https://www.youtube.com/embed/${
              this.state.youTubeURL
            }?rel=0&amp;showinfo=0`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </Modal>
      );
    }
    return null;
  }

  render() {
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <section>
        <Helmet>
          <link
            rel="stylesheet"
            type="text/css"
            charset="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
          />
        </Helmet>
        <div className="bg-lightGrey py-5" style={{ background: "#F6F6F6" }}>
          <div className="container marketingSection">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h2>WHY YOCO?</h2>
                <h3>It works for you.</h3>
                <p>
                  Every day more than {config.merchants} businesses rely on Yoco
                  to get paid.
                </p>
                <p> See what some of them have to say.</p>
              </div>
              <div className="col-md-2 text-center " />
              <div
                className="col-md-6 text-center "
                style={{ cursor: "pointer" }}
              >
                <Slider {...settings}>
                  <div>
                    <img
                      src={youtubePreview1}
                      className="img-fluid"
                      alt=""
                      style={{ maxWidth: "500px", cursor: "pointer" }}
                      onClick={() => this.openModal("ys5IglsrNwQ")}
                    />
                    <br />
                    <h2>See why Yoco is for On the Grind</h2>
                  </div>
                  <div>
                    <img
                      src={youtubePreview2}
                      className="img-fluid"
                      alt=""
                      style={{ maxWidth: "500px", cursor: "pointer" }}
                      onClick={() => this.openModal("lrYJXPFl7Ts")}
                    />
                    <br />
                    <h2>See why Yoco is for Orejen</h2>
                  </div>
                  <div>
                    <img
                      src={youtubePreview3}
                      className="img-fluid"
                      alt=""
                      style={{ maxWidth: "500px", cursor: "pointer" }}
                      onClick={() => this.openModal("-unz19LeJOI")}
                    />
                    <br />
                    <h2>See why Yoco is for Walkfresh</h2>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
        {this.renderModal()}
      </section>
    );
  }
}

export default Entrepreneurs;



// WEBPACK FOOTER //
// ./src/sections/signupPage/entrepreneurs/entrepreneurs.js